import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReferenceBrandType } from '@1po/1po-bff-fe-spec/generated/catalog/references/common/model/ReferenceBrandType';
import { MyStoreTireRimSizeType } from '@1po/1po-bff-fe-spec/generated/my_store/tires/request/UpdateMyStoreTireDiscount';
import { RootState } from 'app/AppStore';
import {
  getMyStoreTiresDiscount,
  getMyStoreTiresDiscountChange,
  setMyStoreTiresChange,
} from 'domains/myStore/MyStore.store';
import { SValidatedInputNumber } from './MyStoreDiscountInput.styled';

interface MyStoreDiscountInputProps {
  brand: ReferenceBrandType;
  tireRimSizeType: MyStoreTireRimSizeType;
}

export const MyStoreDiscountInput = ({ brand, tireRimSizeType }: MyStoreDiscountInputProps) => {
  const dispatch = useDispatch();

  const defaultMyStoreTireDiscount =
    useSelector((state: RootState) => getMyStoreTiresDiscount(state, { brand, tireRimSizeType }))?.discount ?? 0;

  const getUsersChangedValue = useSelector((state: RootState) =>
    getMyStoreTiresDiscountChange(state, { brand, tireRimSizeType }),
  );

  // when new data from server arrives
  useEffect(() => {
    getUsersChangedValue === undefined && setDiscount(defaultMyStoreTireDiscount);
  }, [defaultMyStoreTireDiscount, getUsersChangedValue]);

  // when cancel button is pressed
  useEffect(() => {
    getUsersChangedValue === undefined && setDiscount(defaultMyStoreTireDiscount);
  }, [defaultMyStoreTireDiscount, getUsersChangedValue]);

  useEffect(() => {
    setDiscount(getUsersChangedValue ?? defaultMyStoreTireDiscount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [discount, setDiscount] = useState<number | undefined>();

  return (
    <SValidatedInputNumber
      status={getUsersChangedValue && getUsersChangedValue !== defaultMyStoreTireDiscount ? 'warning' : undefined}
      value={Number(discount)}
      min={0}
      max={100}
      precisionMin={0}
      precisionMax={2}
      isValid={discount !== undefined}
      onBlur={(newValue) => {
        setDiscount(Number(newValue));
        dispatch(setMyStoreTiresChange({ item: { brandId: brand, tireRimSizeType, discount: Number(newValue) } }));
      }}
    />
  );
};
